let NO_OF_AVATARS = 60;

let avatars = {};

for (let i = 0; i< NO_OF_AVATARS; i++) {
    avatars[`avatar${i}`] =  `/avatars/Avatar_${i + 1}.svg`;
}

export default avatars;
